document.addEventListener("DOMContentLoaded", () => {
    const SWIPER_SELECTOR = ".l60-ultra-product-featured-pc-swiper";
    const ITEM_SELECTOR = ".new-common-featured-item";
    const INIT_CLASS = "l60-accordion-initialized";
    const ACTIVE_CLASS = "l60-accordion-active";
    const BREAKPOINT = 768;
  
    const extractTitle = (item) => {
      const titleEl = item.querySelector(".common-title") || 
                      item.querySelector(".title-box")?.parentElement || 
                      item.querySelector(".common-subtitle .title");
                      
      const text = titleEl ? (titleEl.textContent.trim() || titleEl.innerHTML) : "";
      return { el: titleEl, text };
    };
  
    const createAccordionButton = (titleText) => {
      const btn = document.createElement("div");
      btn.className = "l60-accordion-btn";
      btn.innerHTML = `
        <div class="l60-accordion-title">${titleText}</div>
        <button class="l60-accordion-icon">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"> 
            <path d="M24.9978 18.7418L16.1687 27.3018C16.0237 27.4439 15.8511 27.5566 15.6611 27.6335C15.471 27.7104 15.2671 27.75 15.0612 27.75C14.8552 27.75 14.6513 27.7104 14.4612 27.6335C14.2712 27.5566 14.0986 27.4439 13.9536 27.3018C13.6631 27.018 13.5 26.634 13.5 26.2337C13.5 25.8335 13.6631 25.4495 13.9536 25.1656L21.6752 17.5903L13.9536 10.0908C13.6631 9.80689 13.5 9.42289 13.5 9.02264C13.5 8.62238 13.6631 8.23838 13.9536 7.95452C14.0981 7.81136 14.2704 7.69747 14.4605 7.61945C14.6506 7.54143 14.8548 7.50083 15.0612 7.5C15.2675 7.50083 15.4717 7.54143 15.6618 7.61945C15.8519 7.69747 16.0242 7.81136 16.1687 7.95452L24.9978 16.5146C25.1562 16.6565 25.2825 16.8287 25.3689 17.0203C25.4554 17.212 25.5 17.419 25.5 17.6282C25.5 17.8374 25.4554 18.0444 25.3689 18.236C25.2825 18.4277 25.1562 18.5999 24.9978 18.7418Z" fill="#999999" fill-opacity="0.8"/> 
          </svg>
        </button>
      `;
      return btn;
    };
  
    const initAccordion = () => {
      document.querySelectorAll(SWIPER_SELECTOR).forEach((section) => {
        if (section.classList.contains(INIT_CLASS)) return;
        section.classList.add(INIT_CLASS);
  
        section.querySelectorAll(ITEM_SELECTOR).forEach((item, index) => {
          const { el: titleEl, text: extractedText } = extractTitle(item);
          const titleText = extractedText || `Item ${index + 1}`;
  
          if (titleEl) {
            titleEl.classList.add("l60-accordion-original-title");
          }
  
          const inner = item.querySelector(".pfi-inner");
          if (!inner) return;
  
          const accordionBtn = createAccordionButton(titleText);
          inner.insertBefore(accordionBtn, inner.firstChild);
  
          const contentWrapper = document.createElement("div");
          contentWrapper.className = "l60-accordion-content-wrapper";
  
          ["content", "image", "additional_content"].forEach(cls => {
            const el = inner.querySelector(`.${cls}`);
            if (el) contentWrapper.appendChild(el);
          });
  
          inner.appendChild(contentWrapper);
  
          if (index === 0) {
            item.classList.add(ACTIVE_CLASS);
          }
  
          accordionBtn.addEventListener("click", () => {
            const isActive = item.classList.contains(ACTIVE_CLASS);
            
            section.querySelectorAll(ITEM_SELECTOR).forEach((siblingItem) => {
              siblingItem.classList.remove(ACTIVE_CLASS);
            });
            
            if (!isActive) {
              item.classList.add(ACTIVE_CLASS);
            }
          });
        });
      });
    };
  
    const destroyAccordion = () => {
      document.querySelectorAll(SWIPER_SELECTOR).forEach((section) => {
        if (!section.classList.contains(INIT_CLASS)) return;
        section.classList.remove(INIT_CLASS);
  
        section.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
          item.classList.remove(ACTIVE_CLASS);
  
          const originalTitle = item.querySelector(".l60-accordion-original-title");
          if (originalTitle) {
            originalTitle.classList.remove("l60-accordion-original-title");
          }
  
          const inner = item.querySelector(".pfi-inner");
          if (!inner) return;
  
          inner.querySelector(".l60-accordion-btn")?.remove();
  
          const wrapper = inner.querySelector(".l60-accordion-content-wrapper");
          if (wrapper) {
            ["image", "content", "additional_content"].forEach(cls => {
              const el = wrapper.querySelector(`.${cls}`);
              if (el) inner.appendChild(el);
            });
  
            while (wrapper.firstChild) {
              inner.appendChild(wrapper.firstChild);
            }
            wrapper.remove();
          }
        });
      });
    };
  
    const updateSwiperLayout = () => {
      document.querySelectorAll(SWIPER_SELECTOR).forEach((section) => {
        if (section.swiper?.update) section.swiper.update();
        
        section.querySelectorAll(".swiper, .swiper-container").forEach((container) => {
          if (container.swiper?.update) container.swiper.update();
        });
      });
    };
  
    const checkAndUpdateAccordion = () => {
      window.innerWidth <= BREAKPOINT ? initAccordion() : destroyAccordion();
    };
  
    checkAndUpdateAccordion();
  
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        checkAndUpdateAccordion();
        updateSwiperLayout();
      }, 100);
    });
  });
  